import React, { Component } from 'react';

export default class FormInput extends Component{
    render(){
        let readOnly = this.props.readOnly === true ? true : false;

        return(
            <input
                type="text"
                placeholder={this.props.placeholder}
                value={this.props.value}
                onBlur={this.props.onChangeHandler}
                readOnly={readOnly}
                className="appointment_input"
                name={this.props.name}
                id={this.props.id}
            />
        );
    }
}


// WEBPACK FOOTER //
// frontend/src/modules/AppointmentForm/FormInput.js